import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImagesConfig } from '@qaroni-core/config/app/images.config';

@Component({
  selector: 'qaroni-empty-result-preview',
  templateUrl: './empty-result-preview.component.html',
  styleUrls: ['./empty-result-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmptyResultPreviewComponent {
  readonly message = input<string>('No se han encontrado resultados');
  public emptyResult = ImagesConfig.emptyResult;
}
